import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

export const langauges = ['en', 'zh'];

i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    fallbackLng: langauges,
    debug: false,
    lowerCaseLng: true,
    lng: langauges.includes(localStorage.i18nextLng) && localStorage.i18nextLng || 'zh',
    pageDefaultLanguage: langauges.includes(localStorage.i18nextLng) && localStorage.i18nextLng || 'zh',
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/translation.json`
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      useSuspense: true
    }
  })
  .then(t => (window.t = t));

export default i18n;
